import { writable, derived } from 'svelte/store'
import { sortBy } from 'underscore'

export const auth = writable({})
export const sheets = writable([])
export const currentSheet = writable(null)
export const marketSheetItems = writable([])
export const vendors = writable([])
export const squareItems = writable([])
export const locations = writable([])

export const currentVendor = derived(auth, ($auth) => $auth.user.vendor || null)

export const isVendor = derived(
  auth,
  ($auth) => $auth && $auth.user.role.id === 1
)

export const isStaff = derived(
  auth,
  ($auth) => $auth && $auth.user.role.type === 'staff'
)

export const isAdmin = derived(
  auth,
  ($auth) => $auth && $auth.user.role.type === 'admin'
)

export const currentLocation = derived(auth, ($auth) => $auth.user.location)

export const sortedVendors = derived(vendors, ($vendors) =>
  sortBy($vendors, (vendor) => vendor.name.toLowerCase())
)
